import styled from "styled-components";

import DropdownMenuGroup from "../DropdownMenuGroup/DropdownMenuGroup";
import DropdownMenuTextLink from "../DropdownMenuTextLink/DropdownMenuTextLink";
import NavbarDropdown from "../NavbarDropdown/NavbarDropdown";
import Trigger from "../Trigger/Trigger";
import messages from "Header/NavbarRevamp/constants/navbarRevamp.messages";
import { ConnectionsDropdownIds } from "Header/NavbarRevamp/navbarRevamp.ids";
import createAbsolutePath from "createAbsolutePath";

const NavbarConnectionsDropdownContainer = styled.div`
  display: flex;
`;

const NavbarConnectionsDropdown = () => (
  <NavbarConnectionsDropdownContainer>
    <NavbarDropdown
      trigger={
        <Trigger
          label={messages.connections}
          id={ConnectionsDropdownIds.ConnectionTrigger}
        />
      }
    >
      <DropdownMenuGroup>
        <DropdownMenuTextLink
          to={createAbsolutePath("/matches/current")}
          message={messages.manageConnections}
          id={ConnectionsDropdownIds.ConnectionOptionsManage}
          testId={ConnectionsDropdownIds.ConnectionOptionsManage}
        />
        <DropdownMenuTextLink
          to={createAbsolutePath("/matches/pending")}
          message={messages.pendingConnections}
          id={ConnectionsDropdownIds.ConnectionOptionsRequests}
          testId={ConnectionsDropdownIds.ConnectionOptionsRequests}
        />
      </DropdownMenuGroup>
    </NavbarDropdown>
  </NavbarConnectionsDropdownContainer>
);

export default NavbarConnectionsDropdown;
